/**
 * Rutas internas restringidas — delega a permisos API (`internalRoutesEnabled`).
 */

import { hasInternalRoutesAccess } from '@/config/walletPermissions'

export function isInternalAllowlistedAccount(account: string | null | undefined): boolean {
  return hasInternalRoutesAccess(account)
}
